import React from 'react';
import { AlertTriangle, RefreshCw, XCircle } from 'lucide-react';

const AdminRemarksCard = ({ article, language, onResubmit, onDismiss }) => {
  if (!article || article.status !== 'rejected') return null;

  return (
    <div className="rounded-3xl border border-error-50 bg-error-50/40 p-5 shadow-card sm:p-6">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-error-50">
          <AlertTriangle size={20} className="text-error" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div>
              <h3 className="text-sm font-extrabold text-char-900 line-clamp-1">{article.title}</h3>
              <span className="mt-1 inline-block rounded-full bg-error-50 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-error">
                {language === 'ne' ? 'अस्वीकृत' : 'Rejected'}
              </span>
            </div>
            {onDismiss && (
              <button onClick={() => onDismiss(article.id)} className="shrink-0 rounded-lg p-1 text-char-400 hover:bg-char-50">
                <XCircle size={16} />
              </button>
            )}
          </div>

          <div className="mt-3 space-y-2">
            <div>
              <p className="text-xs font-extrabold uppercase tracking-wider text-char-500">
                {language === 'ne' ? 'कारण' : 'Reason'}
              </p>
              <p className="mt-0.5 text-sm text-char-700">
                {article.adminRemark || (language === 'ne' ? 'कुनै टिप्पणी छैन' : 'No remarks provided')}
              </p>
            </div>
          </div>

          {onResubmit && (
            <button
              onClick={() => onResubmit(article)}
              className="mt-4 flex items-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-extrabold text-white transition-all hover:bg-primary-500"
            >
              <RefreshCw size={15} />
              {language === 'ne' ? 'पुनः पेश गर्नुहोस्' : 'Resubmit Article'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminRemarksCard;
